import { BackendResponseModel, ErrorCodes, RawErrorItem } from '../../models';
import { BaseErrorHandler } from './base-error.handler';

export class MwAuthorizationExceptionHandler extends BaseErrorHandler {
  handle(): BackendResponseModel {
    const error = this.getError();
    const result = new BackendResponseModel();

    if (error) {
      result.addError({
        errorCode: error.errorCode,
        errorDescription: error.message,
        memberName: '',
        errorDetails: '',
      });

      if (
        [ErrorCodes.Forbidden, ErrorCodes.Unauthorized].indexOf(
          error.errorCode
        ) !== -1
      ) {
        result.isShowNotification = false;
      }
    }

    return result;
  }

  canHandle(): boolean {
    return !!this.getError();
  }

  private getError(): RawErrorItem | undefined {
    return this.httpResponseError?.errors?.find(
      (t) =>
        [
          ErrorCodes.InvalidGrant,
          ErrorCodes.Unauthorized,
          ErrorCodes.Forbidden,
        ].indexOf(t.errorCode) !== -1
    );
  }
}
